var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdsBuffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 55,
    viewBox: "-14 -24 58 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0235 11.5822V52.0193C37.0235 53.1137 36.1298 54.0065 35.0386 54.0065H1.99563C1.48914 54.0065 1.02567 53.8146 0.673674 53.4994C0.669763 53.4955 0.665852 53.4915 0.661941 53.4876L0.527008 53.3525C0.525052 53.3506 0.523097 53.3467 0.521141 53.3447C0.202386 52.9923 0.0107422 52.5263 0.0107422 52.0173V12.3439C0.0107422 11.2494 1.84082 9.59497 2.93202 9.59497H35.0366C36.1298 9.59302 37.0235 10.4877 37.0235 11.5822Z",
    fill: "#0D48B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1955 9.56641H10C4.47715 9.56641 0 14.0436 0 19.5664V49.0044C0 51.7658 2.23858 54.0044 5 54.0044H14.1955V9.56641Z",
    fill: "#0D48B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3504 16.3533H2.66211V51.3221H14.3504V16.3533Z",
    fill: "#FFB127"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4985 16.3533H30.2041V51.3221H34.4985V16.3533Z",
    fill: "#EA6A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5785 16.3557H34.499V51.2656H35.5785V16.3557Z",
    fill: "#E3ECEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66263 16.3562H1.4541V51.2661H2.66263V16.3562Z",
    fill: "#E3ECEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2042 16.3557H14.3506V51.2656H30.2042V16.3557Z",
    fill: "#E3ECEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3504 16.3557H2.66211V51.2656H14.3504V16.3557Z",
    fill: "#F2F6F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4995 16.3557H30.2051V51.2656H34.4995V16.3557Z",
    fill: "#C9DADF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H33V10H4V8Z",
    fill: "#0D48B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0198 7.69114V9.14437C33.0198 9.36685 32.8467 9.55082 32.6298 9.56508C32.62 9.56651 32.6115 9.56651 32.6017 9.56651H4.42847C4.41862 9.56651 4.41017 9.56651 4.40031 9.56508C4.18349 9.55082 4.01172 9.36685 4.01172 9.14437V7.69114C4.01172 7.45868 4.19898 7.269 4.42847 7.269H4.54252V0.969771C4.54252 0.775817 4.6805 0.613238 4.86212 0.57901V0.397891C4.86212 0.179693 5.03953 0 5.25635 0H31.7752C31.8766 0 31.9695 0.0399318 32.0399 0.104108C32.0512 0.114091 32.061 0.124074 32.0709 0.135483C32.0737 0.138335 32.0765 0.141187 32.0793 0.145466C32.1356 0.21392 32.1694 0.30234 32.1694 0.397891V0.57901C32.3497 0.614664 32.489 0.777243 32.489 0.969771V7.269H32.6031C32.8326 7.26758 33.0198 7.45725 33.0198 7.69114Z",
    fill: "#DAE2E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8118 9.14295V7.69114C14.8118 7.45868 14.9976 7.269 15.2254 7.269H15.3386V0.969771C15.3386 0.775817 15.4755 0.613238 15.6557 0.57901V0.397891C15.6557 0.179693 15.8318 0 16.047 0H5.24697C5.03178 0 4.85571 0.178267 4.85571 0.397891V0.57901C4.67685 0.614664 4.53852 0.777243 4.53852 0.969771V7.269H4.42533C4.19756 7.269 4.01172 7.45868 4.01172 7.69114V9.14437C4.01172 9.36685 4.18219 9.55082 4.39738 9.56508C4.40717 9.56651 4.41555 9.56651 4.42533 9.56651H15.2254C15.2156 9.56651 15.2072 9.56651 15.1974 9.56508C14.9822 9.54939 14.8118 9.36542 14.8118 9.14295Z",
    fill: "#F2F6F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23296 0.711914H5.55859V7.1505H6.23296V0.711914Z",
    fill: "#BECFD3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6353 0.711914H6.96094V7.1505H7.6353V0.711914Z",
    fill: "#BECFD3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03905 0.711914H8.36328V7.1505H9.03905V0.711914Z",
    fill: "#BECFD3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.44 0.711914H9.76562V7.1505H10.44V0.711914Z",
    fill: "#BECFD3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8414 0.711914H11.167V7.1505H11.8414V0.711914Z",
    fill: "#BECFD3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2451 0.711914H12.5693V7.1505H13.2451V0.711914Z",
    fill: "#BECFD3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.646 0.711914H13.9717V7.1505H14.646V0.711914Z",
    fill: "#BECFD3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0484 0.711914H15.374V7.1505H16.0484V0.711914Z",
    fill: "#BECFD3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4507 0.711914H16.7764V7.1505H17.4507V0.711914Z",
    fill: "#BECFD3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8531 0.711914H18.1787V7.1505H18.8531V0.711914Z",
    fill: "#BECFD3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2564 0.711914H19.582V7.1505H20.2564V0.711914Z",
    fill: "#BECFD3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6601 0.711914H20.9844V7.1505H21.6601V0.711914Z",
    fill: "#BECFD3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0611 0.711914H22.3867V7.1505H23.0611V0.711914Z",
    fill: "#BECFD3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4648 0.711914H23.7891V7.1505H24.4648V0.711914Z",
    fill: "#BECFD3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8672 0.711914H25.1914V7.1505H25.8672V0.711914Z",
    fill: "#BECFD3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2695 0.711914H26.5938V7.1505H27.2695V0.711914Z",
    fill: "#BECFD3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6709 0.711914H27.9951V7.1505H28.6709V0.711914Z",
    fill: "#BECFD3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0718 0.711914H29.3975V7.1505H30.0718V0.711914Z",
    fill: "#BECFD3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4742 0.711914H30.7998V7.1505H31.4742V0.711914Z",
    fill: "#BECFD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsBuffer);
export default __webpack_public_path__ + "static/media/SDSBuffer.69549ea98facb05cb942d84e188e5512.svg";
export { ForwardRef as ReactComponent };